import { Col, Row, Statistic, Table, Tag, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import useApi from "../../utils/useApi";
import { formatDate } from "../ai-reports/status";
import { formatNumber, formatUsd } from "./labels";

const { Text } = Typography;

export default function UsageCard({ filtros, onSelecionarCliente }) {
  const { getAgentUsage } = useApi();
  const { data, isFetching } = useQuery({
    queryKey: ["agent-usage", filtros.inicio, filtros.fim, filtros.client_id],
    queryFn: () =>
      getAgentUsage({
        inicio: filtros.inicio,
        fim: filtros.fim,
        client_id: filtros.client_id,
      }),
    staleTime: 0,
  });

  const totais = data?.totais || {};

  return (
    <div>
      <Row gutter={24} style={{ marginBottom: 16 }}>
        <Col xs={12} md={6}>
          <Statistic
            title="Custo no período"
            value={formatUsd(totais.custo)}
            loading={isFetching && !data}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title="Respostas"
            value={formatNumber(totais.respostas)}
            loading={isFetching && !data}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title="Conversas"
            value={formatNumber(totais.conversas)}
            loading={isFetching && !data}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title="Respostas com problema"
            value={formatNumber(totais.problemas)}
            valueStyle={totais.problemas ? { color: "#cf1322" } : undefined}
            loading={isFetching && !data}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} lg={12}>
          <Text strong>Por cliente</Text>
          <Table
            size="small"
            rowKey="client_id"
            loading={isFetching && !data}
            dataSource={data?.por_cliente || []}
            pagination={false}
            locale={{ emptyText: "Sem uso no período." }}
            onRow={(linha) => ({
              onClick: () => onSelecionarCliente(linha.client_id),
              style: { cursor: "pointer" },
            })}
            columns={[
              { title: "Cliente", dataIndex: "cliente", key: "cliente" },
              {
                title: "Conversas",
                dataIndex: "conversas",
                key: "conversas",
                align: "right",
              },
              {
                title: "Respostas",
                dataIndex: "respostas",
                key: "respostas",
                align: "right",
              },
              {
                title: "Problemas",
                dataIndex: "problemas",
                key: "problemas",
                align: "right",
                render: (v) => (v ? <Tag color="error">{v}</Tag> : 0),
              },
              {
                title: "Custo",
                dataIndex: "custo_usd",
                key: "custo",
                align: "right",
                render: (v) => formatUsd(v),
              },
            ]}
          />
        </Col>
        <Col xs={24} lg={6}>
          <Text strong>Por dia</Text>
          <Table
            size="small"
            rowKey="dia"
            loading={isFetching && !data}
            dataSource={[...(data?.por_dia || [])].reverse()}
            pagination={{ pageSize: 10, size: "small" }}
            locale={{ emptyText: "—" }}
            columns={[
              {
                title: "Dia",
                dataIndex: "dia",
                key: "dia",
                render: formatDate,
              },
              {
                title: "Respostas",
                dataIndex: "respostas",
                key: "respostas",
                align: "right",
              },
              {
                title: "Custo",
                dataIndex: "custo_usd",
                key: "custo",
                align: "right",
                render: (v) => formatUsd(v),
              },
            ]}
          />
        </Col>
        <Col xs={24} lg={6}>
          <Text strong>Por modelo</Text>
          <Table
            size="small"
            rowKey="modelo"
            loading={isFetching && !data}
            dataSource={data?.por_modelo || []}
            pagination={false}
            locale={{ emptyText: "—" }}
            columns={[
              { title: "Modelo", dataIndex: "modelo", key: "modelo" },
              {
                title: "Respostas",
                dataIndex: "respostas",
                key: "respostas",
                align: "right",
              },
              {
                title: "Custo",
                dataIndex: "custo_usd",
                key: "custo",
                align: "right",
                render: (v) => formatUsd(v),
              },
            ]}
          />
        </Col>
      </Row>
    </div>
  );
}
